module.exports = __webpack_public_path__ + "img/beer_id-7.0e7f61c9.jpg";